export default __webpack_public_path__ + "static/media/icon-download.6ae0d357.svg";